/**
 * DevExtreme (esm/ui/scroll_view.js)
 * Version: 23.1.5
 * Build date: Wed Aug 30 2023
 *
 * Copyright (c) 2012 - 2023 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import ScrollView from "./scroll_view/ui.scroll_view";
export default ScrollView;
